import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { getGroupsStatus } from './dashboardSlice';
import StarFX from '../game/questionContainer/subcomponents/starFX';

function ScoreboardDashboard() {
  const testModus = true;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [particles, setParticles] = useState([]);
  const cardRefs = React.useRef([]);

  const cookieGameId = Cookies.get('game_id');

  //const groups = useSelector((state) => state.dashboard.groupStatus);

  const groupsData = [
    {
      "group_id": 833,
      "name": "Dragon riders",
      "players": [
        {
          "id": 2498,
          "secret": "c877eb96-be31-46a3-a7a9-48fd67bb74de",
          "game_id": 799,
          "group_id": 833,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        },
        {
          "id": 2499,
          "secret": "1b4a4912-f1d4-4b9a-a710-37b7ab003f09",
          "game_id": 799,
          "group_id": 833,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        },
        {
          "id": 2500,
          "secret": "80439baa-e621-4bf2-999a-9992e2b6c60b",
          "game_id": 799,
          "group_id": 833,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        },
        {
          "id": 2501,
          "secret": "939b311a-5752-48db-b8bd-bf94011efae4",
          "game_id": 799,
          "group_id": 833,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        }
      ],
      "score": 0,
      "rank": 3,
      "missions_started": true
    },
    {
      "group_id": 834,
      "name": "test group",
      "players": [
        {
          "id": 2502,
          "secret": "c5070047-d3dd-4672-bd06-696a2ac2d133",
          "game_id": 799,
          "group_id": 834,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        },
        {
          "id": 2503,
          "secret": "47d64a86-d313-4620-9f5f-725a58b77226",
          "game_id": 799,
          "group_id": 834,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        },
        {
          "id": 2504,
          "secret": "b63ff6a1-ec67-4362-ac2c-6740c0f91bcf",
          "game_id": 799,
          "group_id": 834,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        },
        {
          "id": 2505,
          "secret": "23732eee-254f-4682-848f-f9d905e39114",
          "game_id": 799,
          "group_id": 834,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:14.000000Z",
          "updated_at": "2025-11-13T12:54:14.000000Z"
        }
      ],
      "score": 0,
      "rank": 2,
      "missions_started": true
    },
    {
      "group_id": 835,
      "name": "Group C",
      "players": [
        {
          "id": 2506,
          "secret": "44f03819-4ae7-4a94-8a06-e3046b9ccb92",
          "game_id": 799,
          "group_id": 835,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2507,
          "secret": "ebc484f4-2bf4-4610-a61a-05d1ad3e0647",
          "game_id": 799,
          "group_id": 835,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2508,
          "secret": "5c63c2a9-65d3-48a2-aa69-729001258ad9",
          "game_id": 799,
          "group_id": 835,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 4,
      "missions_started": true
    },
    {
      "group_id": 836,
      "name": "Group D",
      "players": [
        {
          "id": 2509,
          "secret": "3dbcbf07-c7a7-4aea-9961-79159b1e9772",
          "game_id": 799,
          "group_id": 836,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2510,
          "secret": "1d84299b-2776-4f0d-88ff-1741d40336bc",
          "game_id": 799,
          "group_id": 836,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2511,
          "secret": "b8cb115c-3a57-4b9c-a2c1-444027c234af",
          "game_id": 799,
          "group_id": 836,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 4,
      "missions_started": false
    },
    {
      "group_id": 837,
      "name": "Group E",
      "players": [
        {
          "id": 2512,
          "secret": "1877d21e-6b9b-4214-8cc3-ab3eed936a9c",
          "game_id": 799,
          "group_id": 837,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2513,
          "secret": "fe931e62-ac4a-4a64-b65c-9429b1641569",
          "game_id": 799,
          "group_id": 837,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2514,
          "secret": "60eaf399-ef17-4387-a165-2df3807cd1f8",
          "game_id": 799,
          "group_id": 837,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 1,
      "missions_started": true
    },
    {
      "group_id": 838,
      "name": "Group F",
      "players": [
        {
          "id": 2515,
          "secret": "04a23085-6151-4f76-86b4-572ad92630d9",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2516,
          "secret": "990a91bc-d792-4395-a685-c9d611bbfa7e",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2517,
          "secret": "ece6a4ce-af71-4598-92f0-79601352429d",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 6,
      "missions_started": false
    },
    {
      "group_id": 839,
      "name": "Group F",
      "players": [
        {
          "id": 2515,
          "secret": "04a23085-6151-4f76-86b4-572ad92630d9",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2516,
          "secret": "990a91bc-d792-4395-a685-c9d611bbfa7e",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2517,
          "secret": "ece6a4ce-af71-4598-92f0-79601352429d",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 6,
      "missions_started": false
    },
    {
      "group_id": 840,
      "name": "Group F",
      "players": [
        {
          "id": 2515,
          "secret": "04a23085-6151-4f76-86b4-572ad92630d9",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2516,
          "secret": "990a91bc-d792-4395-a685-c9d611bbfa7e",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2517,
          "secret": "ece6a4ce-af71-4598-92f0-79601352429d",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 6,
      "missions_started": false
    },
    {
      "group_id": 841,
      "name": "Group F",
      "players": [
        {
          "id": 2515,
          "secret": "04a23085-6151-4f76-86b4-572ad92630d9",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2516,
          "secret": "990a91bc-d792-4395-a685-c9d611bbfa7e",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2517,
          "secret": "ece6a4ce-af71-4598-92f0-79601352429d",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 6,
      "missions_started": false
    },
    {
      "group_id": 842,
      "name": "Group F",
      "players": [
        {
          "id": 2515,
          "secret": "04a23085-6151-4f76-86b4-572ad92630d9",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2516,
          "secret": "990a91bc-d792-4395-a685-c9d611bbfa7e",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        },
        {
          "id": 2517,
          "secret": "ece6a4ce-af71-4598-92f0-79601352429d",
          "game_id": 799,
          "group_id": 838,
          "name": null,
          "role": null,
          "user_assigned": 0,
          "status": "new",
          "avatar": null,
          "data": null,
          "created_at": "2025-11-13T12:54:15.000000Z",
          "updated_at": "2025-11-13T12:54:15.000000Z"
        }
      ],
      "score": 0,
      "rank": 6,
      "missions_started": false
    }
  ];

  //const [groups, setGroups] = useState(groupsData);
  const groups = useSelector((state) => state.dashboard.groupStatus);

  useEffect(() => {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#292929');
    dispatch(getGroupsStatus(cookieGameId));

    // let interval = setInterval(() => {
    //     dispatch(getGroupsStatus(cookieGameId));
    // }, 3000);

    // return () => clearInterval(interval);

  }, []);

  useEffect(() => {
    if (groups && groups.length > 0) {
      groups.forEach((group) => {
        if (group.score > group.oldScore && group.missions_started) {
          const cardElement = cardRefs.current[group.group_id];
          if (cardElement) {
            console.log('Emit particles for group', group.group_id);
            const rect = cardElement.getBoundingClientRect();
            const x = rect.left + (rect.width - rect.width / 4);
            const y = rect.top + (rect.height / 6);
            const amount = group.score - group.oldScore;
            emitParticles(group.group_id, x, y, amount);
          }
        }
      });
    }
  }, [groups]);

  const getAnimationClass = (group) => {
    let animClass = '';
    if (group.missions_started) {
      if (group.rank === 1 && group.oldRank !== 1) {
        animClass = 'first-place-animation';
      } else if (group.rank === 2 && group.oldRank !== 2) {
        animClass = 'second-place-animation';
      } else if (group.rank === 3 && group.oldRank !== 3) {
        animClass = 'third-place-animation';
      } else if (group.rank > group.oldRank) {
        animClass = 'improved-rank';
      }

      if (group.score > group.oldScore) {
        const newStars = group.score - group.oldScore;
        animClass = ' star-animation';
        if (newStars === 1) {
          animClass += ' star-animation-1';
        } else if (newStars === 2) {
          animClass += ' star-animation-2';
        } else if (newStars === 3) {
          animClass += ' star-animation-3';
        }
      }
    }
    return animClass;
  }

  const emitParticles = (groupId, x, y, amount) => {
    console.log('emit', groupId);
    const newParticles = Array.from({ length: 2 + amount }, (_, i) => ({
      id: `${groupId}-${Date.now()}-${i}`,
      x,
      y,
      r: Math.random() * 180,
      s: Math.random() * 2 + 0.5,
      vx: (Math.random() - 0.5) * 4,
      vy: (Math.random() - 0.5) * 4,
      vr: (Math.random() * 180) * 1.5,
    }));

    setParticles(prev => [...prev, ...newParticles]);

    setTimeout(() => {
      setParticles(prev =>
        prev.filter(p => !newParticles.some(np => np.id === p.id))
      );
    }, 3000);

  };

  useEffect(() => {
    console.log('P', particles)
  }, [particles])

  /*
  const testingGroupUpdate = () => {
    console.log("UPDATE DATA")
    const currentGroupsData = [...groups];
    currentGroupsData.forEach((group) => {
      if (Math.random() < .2) {
        group.oldScore = group.score;
        group.score += Math.floor(Math.random() * 3);
        group.oldRank = group.rank;
        group.rank = Math.floor(Math.random() * 10);
      } else {
        group.oldScore = group.score;
        group.oldRank = group.rank;
      }
      if (Math.random() < .2) {
        group.missions_started = false;
      } else {
        group.missions_started = true;
      }
    });
    setGroups(currentGroupsData);
  }*/

  return (
    <>
      <div className="dashboard-container scoreboard-digiboard">
        {/*<button onClick={testingGroupUpdate}>Test!</button>*/}
        <div className="groups-wrapper">
          {groups &&
            [...groups].sort((a, b) => a.group_id > b.group_id ? 1 : -1).map((group, key) => (
              <div className={`card-wrapper ${groups.length > 8 ? 'dense-layout' : ''}`} key={group.group_id} ref={el => cardRefs.current[group.group_id] = el}>
                <div className={`player-card
                          ${group.missions_started ? '' : 'waiting'}
                          ${group.missions_started && group.rank === 1 ? 'first-place' : ''}
                          ${getAnimationClass(group)}`
                }>
                  <div className="card-background"></div>
                  {(group.rank > group.oldRank && group.missions_started) &&
                    <div className="win-accent"></div>
                  }
                  <div className="particle-container"></div>
                  <div className="team-avatar-container">
                    <img className="team-avatar" src={`/storage/avatar/group_${group.group_id}.png?${new Date().getTime()}`} />
                  </div>
                  <div className="card-frame">&nbsp;</div>
                  {group.missions_started === false &&
                    <div className="wait-indicator">
                      <div className="ornament"></div>
                      <div className="indicator-container">
                        <div className="indicator"></div>
                      </div>
                    </div>
                  }
                  <div className="card-border-accent">&nbsp;</div>
                  <div className="card-message-ribbon">
                    <span className="message">{t("digiboard.group-pending")}</span>
                  </div>
                  <div className="card-ribbon">
                    <div className="team-rank">
                      <div className="rank-accent">&nbsp;</div>
                      <div className="rank-indicator">&nbsp;</div>
                      <div className="rank-value">{group.rank}</div>
                    </div>
                    <div className="team-name">{group.name}</div>
                  </div>
                </div>
              </div>
            ))};
        </div>
        <div className="score-board-wrapper">
          <div className='title-wrapper'>
            <div className='title'>
              <h3>{t("student.groups_overview.rankings")}</h3>
            </div>
            <div className='ornament-left'></div>
            <div className='ornament-right'></div>
            <div className='ornament-rays'>
              <StarFX />
            </div>
          </div>

          <ul className="group-list frameGoldOpen multi">
            {groups &&
              [...groups]
                .filter(group => group.missions_started)
                .sort((a, b) => a.rank - b.rank)
                .map((group, key) => (
                  <li key={group.group_id} className={`group-item ${key === 0 ? 'first' : ''} ${key === 1 ? 'second' : ''} ${key === 2 ? 'third' : ''} ${key > 2 ? 'neutral' : ''}`}>
                    <div className="group-position"><span className="number">{group.rank}</span></div>
                    <div className="group-title">
                      <div className="group-name">{group.name}</div>
                      <div className="group-score">{group.players && group.players.map((player) => player.name).join(", ")}</div>
                    </div>
                    <div className="group-score-container">
                      <div className="collectable"></div>
                      <span className="score">{group.score}</span>
                    </div>
                  </li>
                ))}
            <li className="group-item spacer"></li>
            {[...groups]
              .filter(group => !group.missions_started)
              .map((group, key) => (
                <li key={group.group_id} className={`group-item waiting neutral`}>
                  <div className="group-position"><div className="wait-indicator"></div></div>
                  <div className="group-title">
                    <div className="group-name">{group.name}</div>
                    <div className="group-score">{t("digiboard.group-pending")}</div>
                  </div>
                  <div className="group-score-container">
                    <div className="collectable"></div>
                    <span className="multiplier">x</span>
                    <span className="score">{group.score}</span>
                  </div>
                </li>
              ))}
            <li className="group-item devider"></li>
          </ul>
        </div>
      </div>
      <div className="particle-container">
        {particles.map(particle => (
          <div
            className="particle"
            key={particle.id}
            style={{
              left: `${Math.floor(particle.x)}px`,
              top: `${Math.floor(particle.y)}px`,
              transform: `rotate(${particle.r}deg)`,
              '--s': particle.s,
              '--r': particle.r,
              '--vx': particle.vx,
              '--vy': particle.vy,
              '--vr': particle.vr,
            }}
          >
          </div>
        ))}
      </div>
    </>
  );
}

export default ScoreboardDashboard;

/*

<div className="content-wrapper">
              <div className="game-board">
                  <div className="groups-wrapper">
                  {groups &&
                    [...groups].sort((a,b) => a.group_id > b.group_id ? 1 : -1).map((group, key) => (
                        <div className={`group-wrapper ${group.missions_started ? '' : 'waiting'} ${ group.missions_started && group.rank === 1 ? 'first-place' : ''} ${group.missions_started && group.rank === 2 ? 'second-place' : ''} ${ getAnimationClass(group)}`} key={group.group_id}>
                        <div className="group-card">
                            <div className="group-avatar-wrapper" style={{ backgroundImage: `url('/storage/avatar/group_${group.group_id}.png')` }}>

                                <div className="loading-banner">
                                    <span>Groep samenstellen...</span>
                                </div>
                            </div>
                            <div className="group-name">
                                {group.missions_started && 
                                    <>
                                        <div className="group-old-position">{group.oldRank}</div>
                                        <div className="group-position">{group.rank}</div>
                                    </>
                                }
                                
                                <div className="name">
                                    <span>{group.name}</span>
                                </div>
                            </div>
                            {group.missions_started && group.rank === 1 &&
                                <div className="cup">
                                    <img src="/images/cup.png" alt="cup" width={50} />
                                </div>
                            }
                            
                            <div className="emojis">
                                <div className="animation one-star">
                                    <img src="/images/emoji-star.png" alt="1 star" width={40} />
                                </div>
                                <div className="animation two-stars"></div>
                                <div className="animation three-stars"></div>
                                <div className="animation first-place"></div>
                                <div className="animation thumbsup"></div>
                            </div>
                        </div>
                    </div>
                    ))}
                    {/* <div className="group-wrapper position-change">
                        <div className="group-card">
                            <div className="group-avatar-wrapper">
                            </div>
                            <div className="group-name">
                                <div className="group-position">2</div>
                                <div className="group-position-change">+1</div>
                                <div className="name">
                                    <span>Group 2</span>
                                </div>
                            </div>
                            <div className="cup">

                            </div>
                            <div className="emojis">
                                
                            </div>
                        </div>
                    </div> }
                
                    </div>
                    </div>
                    <div className="score-board-wrapper">
                        <h3>{ t("digiboard.open.title_2") }</h3>
                        <ul className="group-list">
                            {groups &&
                                groups.map((group, key) => (
                                    <li key={group.group_id} className={`${group.missions_started ? '': 'waiting'}`}>
                                        <div className="group-position">
                                            {group.missions_started ? key + 1 : ''}
                                        </div>
                                        <div className="group-details">
                                            <div className="group-name">
                                                {group.name}
                                            </div>
                                            <span className="group-members">
                                                {group.missions_started && group.players &&
                                                    group.players
                                                        .map((player) => player.name)
                                                        .join(", ")}
                                            </span>
                                        </div>
                                        <div className="group-score">
                                          {group.missions_started &&
                                          <div className="group-score-wrapper">
                                              <StarIcon />
                                              <span>x{group.score}</span>
                                          </div>
                                          }
                                          { !group.missions_started && 
                                              <span className="waiting-score">...</span>
                                          }
                                        </div>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </div>*/

/*groups &&
[...groups].sort((a, b) => a.group_id > b.group_id ? 1 : -1).map((group, key) => (
<div className={`group-wrapper ${group.missions_started ? '' : 'waiting'} ${group.missions_started && group.rank === 1 ? 'first-place' : ''} ${group.missions_started && group.rank === 2 ? 'second-place' : ''} ${getAnimationClass(group)}`} key={group.group_id}>
<div className="group-card">
<div className="group-avatar-wrapper">
  <div className="avatar-floor"></div>
  <div className="avatar-image"
    style={{
      backgroundImage: `url('/storage/avatar/group_${group.group_id}.png?${new Date().getTime()}')`,
    }}
  ></div>
  <div className="loading-banner">
    <span>{t("digiboard.group-pending")}</span>
  </div>
</div>
<div className="group-name">
  <>
    <div className="group-old-position">{group.oldRank}</div>
    <div className="group-position">{group.rank}</div>
  </>
  <div className="name">
    <span>{group.name}</span>
  </div>
</div>
{group.missions_started && group.rank === 1 &&
  <div className="cup">
    <img src="/images/cup.png" alt="cup" width={50} />
  </div>
}
<div className="emojis">
  <div className="animation one-star">
    <img src="/images/emoji-star.png" alt="1 star" width={40} />
  </div>
  <div className="animation two-stars"></div>
  <div className="animation three-stars"></div>
  <div className="animation first-place"></div>
  <div className="animation thumbsup"></div>
</div>
</div>
</div>
))*/